module.exports = __webpack_public_path__ + "img/area-limit-btn.243600e7.png";